define('home/views/ChannelDiscussionFeedView',[
    'home/views/common/FetchableCollectionLayout',
    'home/templates/channelDiscussionFeed',
], function (
    FetchableCollectionLayout,
    channelDiscussionFeedTemplate
) {
    'use strict';

    /**
     * The view shown in the tab area of a channel page. Should be used only
     * for discussion feed tabs, as it shows a prompt above the feed prompting the
     * user to begin a discussion.
     */
    var ChannelDiscussionFeedView = FetchableCollectionLayout.extend({
        template: channelDiscussionFeedTemplate,
        templateHelpers: function () {
            return {
                channel: this.channel.toJSON(),
            };
        },

        initialize: function (options) {
            FetchableCollectionLayout.prototype.initialize.call(this, options);
            this.channel = options.channel;
        },
    });

    return ChannelDiscussionFeedView;
});

